import { render, staticRenderFns } from "./answer_type.vue?vue&type=template&id=055c0087&scoped=true&"
import script from "./answer_type.vue?vue&type=script&lang=js&"
export * from "./answer_type.vue?vue&type=script&lang=js&"
import style0 from "./answer_type.vue?vue&type=style&index=0&id=055c0087&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055c0087",
  null
  
)

export default component.exports